import React, { useEffect, useState } from 'react';
import { CargarServicios, CargarServiciosDB } from './CargarServicios';
import ContenedorAnimacion from './ContenedorAnimacion';
import Servicio from '../types/Servicios';
import buildImageSrc from '../functions/buildImageSrc';

const MostrarServicios: React.FC = () => {
  // const serviciosData = CargarServicios();
  const [serviciosCargadosOk, setServiciosCargadosOk] = useState(false);
  const [serviciosData, setServiciosData] = useState<Servicio[]>([]);
  const [serviciosCargados, setServiciosCargados] = useState<Servicio[]>([]);

  /*
  useEffect(() => {
    CargarServiciosDB("activos").then(data => {
        setServiciosData(data);
        data.servicios.forEach((servicio: Servicio) => {
            import(`./../assets/images/servicios/${String(servicio.id).padStart(2, '0')}_st.png`).then((image) => {
                servicio.imageSrc = image.default;
                setServiciosCargados(prevState => [...prevState, servicio]);
            });
        });
        setServiciosCargadosOk(true);
    });
  }, []);
  */

    function mapServicios(servicios: Servicio[]): Servicio[] {
        return servicios.map((servicio) => ({
            ...servicio,
            imageSrc: buildImageSrc(servicio.logo_mime, servicio.logo_content) || ""
        }));
    }
  useEffect(() => {
    CargarServiciosDB("activos").then(data => {
        setServiciosData(data);
        const serviciosConImagenes: Servicio[] = mapServicios(data.servicios);

        setServiciosCargados(serviciosConImagenes);
        setServiciosCargadosOk(true);        
    });
}, []);


  return (
        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
        {serviciosCargadosOk && (serviciosCargados.map(servicio => (
            <ContenedorAnimacion key={servicio.id} animation='zoomIn' duration={800} delay={40} className="">
                <div className="mx-2 my-2 sm:m-4 flex flex-col justify-center items-center text-gray-500 border-l-[4px] border-vp-azul rounded-tr-xl rounded-br-xl shadow-md shadow-vp-gris min-w-[150px] max-w-[220px] group hover:bg-stone-100 transition">
                    <div className="flex flex-col bg-stone-100 w-full justify-center items-center pt-2 rounded-tr-xl group-hover:bg-stone-200 transition">
                        <div className="w-20 h-20 rounded-full border-2 border-vp-azulclaro object-contain bg-white group-hover:shadow-lg group-hover:shadow-vp-gris transition ">
                            <img src={servicio.imageSrc} alt={servicio.nombre} className="mx-auto p-2" />
                        </div>
                        <div className="flex items-start mt-4 text-truncate-title px-2">
                            <h3 className="font-myriad-pro mb-1 text-lg font-regular text-black text-truncate-title">
                                {servicio.nombre}
                            </h3>
                        </div>
                    </div>
                    <div className="min-h-36 h-36 sm:min-h-32 sm:h-32 flex flex-col justify-start items-start content-start text-left text-sm px-1 mt-2 mb-2 text-truncate-description border-br-xl group-hover:bg-stone-100 transition">
                        <p className="font-myriad-pro text-sm font-regular text-vp-gris text-truncate-description px-1 group-hover:text-black group-hover:bg-stone-100 transition">
                            {servicio.descripcion}
                        </p>
                    </div>
                </div>
            </ContenedorAnimacion>
        )))}
        </div>
    );
};

export default MostrarServicios;
